import _ from 'lodash';
import store from '../store';

interface ValidationObject {
  kind: string // 'required' | 'enum'
  message: string
  name: 'ValidatorError'
  path: 'string'
}

export class ErrorHandlerService {

  static errorMessages: { [tagName: string]: any } = {
    'approveProductionReportErr': (errorObject: any): string => {
      const goodsIds: string = _.map(_.get(errorObject,'response.data.err'), (rmError) => `${rmError.rm}`).join(', ');
      return `Missing RMs: RMs ${goodsIds} have missing quantities`;
    },
    'createPaymentReceiptErr': (errorObject: any): string => {
      const errorType = _.get(errorObject,'response.data.type');
      if(errorType === 'ValidationError') {
        store.commit('setFormValidStatus', { default: errorObject.response.data.err });
        const validationKeys: string[] = Object.keys(_.get(errorObject, 'response.data.err', {}));
        return `${validationKeys.join(',')} is required.`;
      } else {
        return `Something went wrong (${errorType})`;
      }
    },
    'ValidationError': (errorObject: any): string => {
      const validationErrorObject: { [key: string]: ValidationObject } = _.get(errorObject, 'response.data.err', {});
      const requiredFieldValidationObjects = _.filter(validationErrorObject, (fieldError: any) => _.get(fieldError, 'kind') == 'required');
      if(requiredFieldValidationObjects.length == 1) {
        return requiredFieldValidationObjects[0].message;
      } else if(requiredFieldValidationObjects.length > 1) {  
        const requiredFieldNames = requiredFieldValidationObjects.map((validationObject: ValidationObject) =>
          validationObject.message.replace(/`/g,'').replace('Path ','').replace(' is required.', '').replace(' are required', '')
        );
        return `${requiredFieldNames.join(', ')} are required.`;  
      } else {
        const nonRequiredFieldValidationObject = _.find(validationErrorObject, (fieldError: any) => _.get(fieldError, 'kind') != 'required');
        return _.get(nonRequiredFieldValidationObject, 'message', 'Validation Error');
      }
    }
  };

  static getErrorMessage(errorObject: any): string {
    const errorMessage = _.get(errorObject,'response.data.reason') || _.get(errorObject,'response.data.message');
    if(errorMessage) return errorMessage;
    const errorTag = _.get(errorObject,'response.data.tag');
    if(ErrorHandlerService.errorMessages[errorTag]) {
      return ErrorHandlerService.errorMessages[errorTag](errorObject);
    } else {
      if(['Validation Error', 'ValidationError'].includes(_.get(errorObject,'response.data.type'))) {
        store.commit('setFormValidStatus', { default: errorObject.response.data.err });
        return ErrorHandlerService.errorMessages['ValidationError'](errorObject);
      } else {
        return `Something went wrong (${errorTag})`;
      }
    }
  }

  static handleError(errorObject: any) {
    let serverMessage = '';
    if(typeof(errorObject.response.data.err) == 'string') {
      serverMessage = errorObject.response.data.err;
    } else {
      serverMessage = ErrorHandlerService.getErrorMessage(errorObject);
    }
    store.commit('setSnackbar', { serverMessage, show: true, color: 'error' });
  }
}